import GradeLessonPage from '../components/GradeLessonPage';
import { apCalcBCData } from './data';

export default function APCalcBCPage() {
  return (
    <GradeLessonPage
      grade="ap-calc-bc"
      gradeLabel="AP Calculus BC"
      gradeColor="teal"
      topics={apCalcBCData}
      prevGrade={{ label: 'AP Calculus AB', path: '/ap-calc-ab' }}
      nextGrade={null}
    />
  );
}
